export default __webpack_public_path__ + "static/media/recrutementsLogo.a673b834.png";